import React from "react";
import { ProductPriceWatchdogFormData } from "./ProductPriceWatchdogForm";
import currencyFormatter, { Currency } from "@/common/CurrencyFormatter";

interface ProductPriceWatchdogSubmittedProperties {
    readonly onClose: () => void;
    readonly submittedData: ProductPriceWatchdogFormData;
    readonly currency: Currency;
}

export default function ProductPriceWatchdogSubmitted({ onClose, submittedData, currency }: ProductPriceWatchdogSubmittedProperties): React.JSX.Element {
    return (
        <div className="modal-body shop-body">
            <div className="price-watchdog-confirm">
                <p className="fakeh3">Píšu si Vás...</p>
                <p>... a jakmile cena tohoto produktu klesne <strong>pod
                    <span>{currencyFormatter.formatCurrencyWithSymbol(submittedData.price, currency)}</span>
                </strong>, dám Vám vědět na
                    e-mail <strong><span>{submittedData.email}</span></strong>
                </p>
                <div className="watchdog-confirmation-images">
                    <img src="/css/image/karel-finger-pointing.png" alt="" />
                    <img src="/css/image/price-fall.png" alt="" />
                    <i className="fa-solid fa-envelope"></i>
                </div>
                <div className="text-right shop-body-button">
                    <button type="button" className="btn" onClick={onClose}>Zavřít</button>
                </div>
            </div>
        </div>
    );
}
